module.exports = __webpack_public_path__ + "static/media/upload_share_Selected.caf63237.svg";